import { cn } from "helpers/classNames";

type Props = {
  label: string;
  className?: string;
};

export const LabeledDivider = ({ label, className }: Props) => (
  <div className={cn("flex items-center gap-3", className)}>
    <div className="h-px flex-1 bg-gray-200" />
    <span className="text-xs font-medium uppercase tracking-wide text-gray-400">
      {label}
    </span>
    <div className="h-px flex-1 bg-gray-200" />
  </div>
);
